const header = (): void => {
  const classes = {
    hamburgerOpen: 'desktop-nav__hamburger--open',
    searchModalOpen: 'body--search-modal-open',
    mobileNavOpen: 'body--mobile-nav-open',
  };

  const selectors = {
    mobileMenuToggle: '[data-mobile-menu-toggle]',
    mobileNavOverlay: '[data-mobile-nav-overlay]',
    searchModalToggle: '[data-search-modal-toggle]',
    searchModalInput: '[data-search-form] [type="search"]',
  };

  const mobileMenuToggle = document.querySelector(selectors.mobileMenuToggle);
  const mobileNavOverlay = document.querySelector(selectors.mobileNavOverlay);

  mobileMenuToggle?.addEventListener('click', () => {
    document.body.classList.remove(classes.searchModalOpen);
    mobileMenuToggle.classList.toggle(classes.hamburgerOpen);
    document.body.classList.toggle(classes.mobileNavOpen);
  });

  mobileNavOverlay?.addEventListener('click', () => {
    document.body.classList.remove(classes.mobileNavOpen);
    mobileMenuToggle?.classList.remove(classes.hamburgerOpen);
  });

  // Mobile Nav Accordions

  const openAccordion = (
    accordion: HTMLElement,
    accordionContent: HTMLElement
  ): void => {
    accordion.classList.add('menu-item--open');
    accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
  };

  const closeAccordion = (
    accordion: HTMLElement,
    accordionContent: HTMLElement
  ): void => {
    accordion.classList.remove('menu-item--open');
    accordionContent.style.maxHeight = null as any;
  };

  const mobileNavUl = document.querySelector('[data-mobile-nav] > div > ul');

  if (mobileNavUl) {
    const accordionChildren = mobileNavUl.querySelectorAll<HTMLElement>(
      'li.menu-item-has-children'
    );

    accordionChildren.forEach((li) => {
      const accordionToggle = li.querySelector('div');
      const accordionContent = li.querySelector('ul');

      if (accordionToggle && accordionContent) {
        accordionToggle.addEventListener('click', () => {
          if (accordionContent.style.maxHeight) {
            closeAccordion(li, accordionContent);
          } else {
            accordionChildren.forEach((otherAccordion) => {
              const otherContent: any =
                otherAccordion.querySelector<HTMLElement>('ul');
              closeAccordion(otherAccordion, otherContent);
            });

            openAccordion(li, accordionContent);
          }
        });
      }
    });
  }

  const stickyHeader = (): void => {
    const body = document.body;
    const scrollUp = 'body--scrolling-up';
    const scrollDown = 'body--scrolling-down';
    let lastScroll = 0;

    const scrollPositionEvents = ['load', 'scroll'];
    scrollPositionEvents.forEach((event) => {
      window.addEventListener(event, () => {
        const currentScroll = window.scrollY;
        if (currentScroll <= 0) {
          body.classList.remove(scrollUp);
          return;
        }
        if (
          currentScroll > lastScroll &&
          !body.classList.contains(scrollDown)
        ) {
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (
          currentScroll < lastScroll &&
          body.classList.contains(scrollDown)
        ) {
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
      });
    });
  };

  stickyHeader();

  const searchModal = (): void => {
    const searchFormInput = document.querySelector<HTMLInputElement>(
      selectors.searchModalInput
    );
    const searchModalToggle = document.querySelectorAll(
      selectors.searchModalToggle
    );
    if (searchModalToggle) {
      searchModalToggle.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          document.body.classList.remove(classes.mobileNavOpen);
          mobileMenuToggle?.classList.remove(classes.hamburgerOpen);

          if (document.body.classList.contains(classes.searchModalOpen)) {
            document.body.classList.remove(classes.searchModalOpen);
          } else {
            document.body.classList.add(classes.searchModalOpen);
            if (searchFormInput) {
              searchFormInput.focus();
            }
          }
        });
      });
    }
  };

  searchModal();
};

export default header;
